import type { Dispatch, FC, FormEvent, SetStateAction } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary";
import { EmailInput } from "@shared/components";
import { isEmailAtValid, isLengthValid } from "@shared/components/EmailInput";
import { useBreakpoints } from "@shared/hooks";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./ForgotPasswordForm.styles";

interface Props {
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
}

const ForgotPasswordForm: FC<Props> = ({ email, onSubmit, isLoading, setEmail }) => {
  const { tablet } = useBreakpoints();
  const { t } = useTranslation();
  const [isEmailDirty, setIsEmailDirty] = useState(false);

  const handleEmailOnBlur = e => {
    if (e.target.value) {
      setIsEmailDirty(true);
    }
  };

  const isFormValid = !!email && isEmailAtValid(email) && isLengthValid(email);

  return (
    <form css={styles.form} onSubmit={onSubmit}>
      <EmailInput
        onChange={e => setEmail(e.target.value)}
        onBlur={handleEmailOnBlur}
        required
        isDirty={isEmailDirty}
        value={email}
        setEmail={setEmail}
        autoFocus={!email.length}
        wrapperStyles={styles.input}
      />

      <Button
        isLoading={isLoading}
        disabled={!isFormValid}
        type="submit"
        isFullWidth={tablet.lessThan}
      >
        {t(l.signIn.EmailMeLink)}
      </Button>
    </form>
  );
};

export { ForgotPasswordForm };
